import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import i18n from '@/i18n'
import { resetQueries } from '@/utils'

import { RESERVATION_DETAILS_QUERY_KEY } from './get-reservation-details'
import { RESERVATION_TRANSACTIONS_QUERY_KEY } from './get-reservation-transactions'

type ApproveReservationRequest = {
  reservationId: number
}

const approveReservation = async ({ reservationId }: ApproveReservationRequest) => {
  const result = await authAPI.post<string>(`/reservation/status/approve/false`, {
    reservations: [reservationId],
  })

  return result.data
}

export const useApproveReservation = () => {
  return useMutation({
    mutationFn: approveReservation,
    onError: () => {
      toastFactory.error(i18n.t('common:errors.generic'))
    },
    onSuccess: async () => {
      await resetQueries([RESERVATION_DETAILS_QUERY_KEY], [RESERVATION_TRANSACTIONS_QUERY_KEY])
      toastFactory.success(i18n.t('reservations:details.apiMessages.reservationApprovSuccess'))
    },
  })
}
